<template>
  <router-link class="item--1 sidebar-section--3" :to="to" v-on="$listeners">
    <left-icon v-if="leftIcon" :name="leftIcon" />
    <slot />
  </router-link>
</template>

<script>
import LeftIcon from '@/components/SideNav--Item-Icon'
export default {
  name: 'SideNavItem',
  props: {
    to: {
      type: String,
      default: ''
    },
    leftIcon: {
      type: String,
      default: null
    }
  },
  components: {
    LeftIcon
  }
}
</script>
